import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['chip']

  logClick(event) {
    console.log('Chip clicked', event.currentTarget)
  }
}
